import TestimonialList from "./Components/TestimonialList";

const Testimonials = () => {
    window.document.title = "Testimonials";

    return (
        <>
            <div className="container-fluid">
                <div className="page-head sticky_top_padding">
                    <div className="row g-2 align-items-center">
                        <div className="col-lg-6 col-sm mb-3 col-6">
                            <h1 className="h3 text-dim">Testimonials</h1>
                        </div>
                        <div className="col-lg-6 mb-3 col-6">
                            <button type="button" className="btn btn-green btn-lg px-3 float-end" data-bs-toggle="modal" data-bs-target="#upsertTestimonial" title="Add">
                                + Add Testimonial
                            </button>
                        </div>
                    </div>
                </div>
                <TestimonialList />
            </div>
        </>
    )
}
export default Testimonials;